import React, { Component } from 'react';

import Tracker from '../utils/react-google-analytics';

import PrivateComponent from './private.route.jsx';

class AuthRoute extends Component {
  componentDidMount() {
    Tracker.trackInit();
  }

  render() {
    return (
      <div>
        <PrivateComponent {...this.props} path='/' />
      </div>
    );
  }
}

export default AuthRoute;
